import { IHeaderParams } from "ag-grid-community";
import { Menu, ActionIcon } from "@mantine/core";
import { ArrowUp, ArrowDown, ArrowSwapVertical, Filter } from "iconsax-react";
import { client_selected } from "../../client";
import { ESortOrder } from "../../interfaces/IQuery";
import { useTranslation } from "react-i18next";

interface IQuery {
  sortOrder?: ESortOrder | string;
  orderBy?: string;
  page: number;
}

export default function HeaderWithMenu(params: IHeaderParams) {
  const { t } = useTranslation();
  const { query, setQuery, hasFilters } = params.context;

  const color = client_selected.colors.basic[5];
  const backgroundSelected = client_selected.colors.basic[1];
  const columnId = params.column.getColId();

  const filter = columnId.includes("no_filter_");
  const currentSort =
    !!query?.orderBy && query?.orderBy === columnId
      ? query?.sortOrder
      : undefined;

  const applySort = (next: "ASC" | "DESC" | null) => {
    setQuery((prev: IQuery) => ({
      ...prev,
      orderBy: next ? columnId : undefined,
      sortOrder: next || undefined,
      page: 1,
    }));
  };

  return (
    <div
      style={{ display: "flex", alignItems: "center", gap: 6, width: "100%" }}
    >
      <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
        {params.displayName}
      </span>

      {!filter && hasFilters ? (
        <Menu shadow="md" width={200} withinPortal position="bottom-end">
          <Menu.Target>
            <ActionIcon
              variant="subtle"
              aria-label="menu-coluna"
              bg={!!currentSort ? backgroundSelected : undefined}
            >
              <Filter size="20" color={!!currentSort ? color : undefined} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Label>{t("global.aggrid.actions")}</Menu.Label>

            <Menu.Item
              onClick={() => applySort("ASC")}
              icon={<ArrowUp size="14" color={color} />}
              style={{
                background:
                  currentSort === "ASC" ? backgroundSelected : undefined,
              }}
            >
              {t("global.aggrid.order_asc")}
            </Menu.Item>

            <Menu.Item
              onClick={() => applySort("DESC")}
              icon={<ArrowDown size="14" color={color} />}
              style={{
                background:
                  currentSort === "DESC" ? backgroundSelected : undefined,
              }}
            >
              {t("global.aggrid.order_desc")}
            </Menu.Item>

            <Menu.Item
              onClick={() => applySort(null)}
              icon={<ArrowSwapVertical size="14" color={color} />}
            >
              {t("global.aggrid.clean_order")}
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      ) : null}
    </div>
  );
}
